import {
  AttributeDTO,
  AttributeSchemaDTO,
  AttributeValueTypeDTO,
} from '../attribute/types';
import { z } from 'zod/v4';

export const CITypeAttributeModifiersSchemaDTO = z.object({
  ci_type_id: z.uuid(),
  ci_attribute_id: z.uuid(),

  inherited: z.boolean(),
  like_parent: z.boolean(),
  hidden: z.boolean(),
  editable: z.boolean(),
  required: z.boolean(),
  save_history: z.boolean(),
  value_schema: AttributeSchemaDTO,
});
export type CITypeAttributeModifiersSchema = z.infer<
  typeof CITypeAttributeModifiersSchemaDTO
>;

export const CITypeAttributeModifiersUpdateDTO = z.object({
  hidden: z.boolean(),
  editable: z.boolean(),
  required: z.boolean(),
  save_history: z.boolean(),
  like_parent: z.boolean(),
  value_schema: AttributeSchemaDTO,
});
export type CITypeAttributeModifiersUpdate = z.infer<
  typeof CITypeAttributeModifiersUpdateDTO
>;

export const CITypeAttributeDTO = AttributeDTO.extend({
  inherited: z.boolean(),
  like_parent: z.boolean(),
  hidden: z.boolean(),
  editable: z.boolean(),
  required: z.boolean(),
  configured: z.boolean().optional(),
  save_history: z.boolean(),
  value_type: AttributeValueTypeDTO,
});
export type CITypeAttribute = z.infer<typeof CITypeAttributeDTO>;

export const CiTypeAttributesUpdateDTO = z.object({
  attributes: z.array(z.string()),
});
export type CiTypeAttributesUpdate = z.infer<typeof CiTypeAttributesUpdateDTO>;